export default __webpack_public_path__ + "static/media/siteIconHeader.9f112608.svg";